<template>
    <div>
        <top-header/>
        <div v-if="testResults" class="container-fluid" style="margin-bottom: 10rem;">
            <div class="pt-3 no-print pr-2">
                <router-link to="/" class="btn btn-outline-primary">
                    <i class="fas fa-home mr-1"></i><span>Start Over</span>
                </router-link>
                <button class="btn btn-outline-success ml-2" onclick="window.print();return false;">
                    <i class="fas fa-print mr-1"></i><span>Print</span>
                </button>
            </div>
            <div class="row mt-3 pt-2">
                <h1 class="col-12 col-lg-6 text-center text-lg-left text-uppercase text-left m-0 pl-2 p-0">
                    <font-awesome-icon icon="table"/>
                    Test Result
                </h1>
                <div class="col-12 col-lg-6 text-center text-lg-right text-right text-secondary">
                    <span class="date" style="padding-right: 0.4rem;"><font-awesome-icon icon="clock"/></span> <span>{{ testResults.date | moment('dddd, MMMM Do YYYY') }}</span>
                </div>
            </div>

            <hr/>

            <results-overview :test-results="testResults"></results-overview>

            <div class="text-left">
                <result-table v-bind:filters="testResults.filters" data-cy="resultTable"></result-table>
                <div v-if="testResults.playoffRounds && testResults.playoffRounds.length > 0">
                    <h1>
                        <font-awesome-icon icon="dice"/>
                        Playoff Filters History
                    </h1>
                    <hr/>
                    <div v-for="round in testResults.playoffRounds" :key="round.sortOrder">
                        <h2 class="">Playoff Round #{{ round.round }}</h2>
                        <result-table v-bind:filters="round.filters" :data-cy="`playoff${round.round}resultTable`"></result-table>
                    </div>

                </div>
            </div>
        </div>
        <div v-else>
            <i class="fas fa-bug fa-3x text-secondary mt-5"/>
            <h4 class="mt-3">
                Provided Test ID does NOT exist!
            </h4>
        </div>
        <bottom-footer/>
    </div>
</template>

<script>
    import ResultTable from './ResultTable';
    import TopHeader from '../TopHeader';
    import ResultsOverview from './ResultsOverview';
    import BottomFooter from '../decorators/BottomFooter';
    import FiltersService from '../../services/FiltersService';

    export default {
        name: 'ResultsScreen',
        components: {BottomFooter, ResultsOverview, TopHeader, ResultTable},
        data() {
            return {
                testResults: null,
            };
        },
        mounted() {
            const runRes = FiltersService.buildResults(this.$route.params.testId);
            this.testResults = runRes;
        },
    };
</script>

<style lang="scss" scoped>
    .myHeading {
        padding-bottom: 0px;
        margin-bottom: 0px;
    }

    .date {
        font-size: 0.9rem;
    }

    @media print {
        .no-print, .no-print * {
            display: none !important;
        }
    }
</style>
